import FormResultStep from './FormResultStep';
import { EFormSectionType, IForm } from '../interfaces/form.interfaces';

interface IProps {
  form: IForm;
}

const FormResult = ({ form }: IProps): JSX.Element => {
  return (
    <div>
      {form?.sections
        ?.slice(0, -1)
        ?.map(section =>
          section.type !== EFormSectionType.SIGNATURE ? (
            <FormResultStep key={section.uuid} section={section} />
          ) : (
            <></>
          ),
        )}
    </div>
  );
};

export default FormResult;
